<script setup lang="ts">

import {useCartStore} from "../../stores/cart.ts";
import Skeleton from "../Skeleton.vue";

const cartStore = useCartStore()

</script>

<template>
    <Skeleton class="w-12" v-if="cartStore.isLoading"/>
    <template v-else>
        <slot/>
    </template>
</template>
